<template>
    <div id="app">
        <router-view name="header"></router-view>
        <main>
            <fade-transition origin="center" mode="out-in" :duration="250">
                <router-view/>
            </fade-transition>
        </main>
        <router-view name="footer"></router-view>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition
  }
};
</script>

<style>
/* Add styles directly within the <style> tag, or reference an external stylesheet */

#app {
    display: flex; /* Establish a flex container */
    flex-direction: column; /* Arrange children in a column */
    min-height: 100vh; /* Minimum height of the viewport */
    overflow-x: hidden; /* Prevent horizontal scrolling */
}

main {
    display: flex !important; /* Already a flex container */
    flex-direction: column; /* Children are stacked vertically */
    flex-grow: 1; /* It will take up all available space between header and footer */
    width: 100%; /* Full width */
}

html {
  scroll-behavior: smooth;
}


/* Ensure the header and footer have appropriate styles as well */
</style>